import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CommunicationDetailPage } from '@/pages/member-portal/communications/CommunicationDetailPage';
import { CommunicationEditorPage } from '@/pages/member-portal/communications/CommunicationEditorPage';

const communicationDetailSearchSchema = z.looseObject({
	tab: z.enum(['overview', 'responses']).optional().catch(undefined),
	responseStatus: z.enum(['ANSWERED', 'PENDING']).optional().catch(undefined),
});

function MemberPortalManageCommunicationRoute() {
	const { id } = Route.useParams();
	if (id === 'new') return <CommunicationEditorPage />;
	return <CommunicationDetailPage communicationId={id} />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/communications/$id')({
	component: MemberPortalManageCommunicationRoute,
	validateSearch: communicationDetailSearchSchema,
});
